module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/32-1c004f847a06987452a75dfe3706b507.png";